import { accessTokenIdentity } from '@/services/authSessionClaims';

const ACCESS_TOKEN_KEY = 'helios_access_token';
let sessionIdentityGeneration = 0;

function identityChanged(previous: string | null, next: string | null): boolean {
  const previousIdentity = accessTokenIdentity(previous);
  const nextIdentity = accessTokenIdentity(next);
  return previousIdentity !== null || nextIdentity !== null
    ? previousIdentity !== nextIdentity
    : previous !== next;
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key === ACCESS_TOKEN_KEY && identityChanged(event.oldValue, event.newValue)) {
      sessionIdentityGeneration += 1;
    }
  });
}

export function getSessionIdentityGeneration(): number {
  return sessionIdentityGeneration;
}

function hasStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function getAccessToken(): string | null {
  if (!hasStorage()) {
    return null;
  }
  return window.localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string): void {
  if (hasStorage()) {
    if (identityChanged(getAccessToken(), token)) sessionIdentityGeneration += 1;
    window.localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }
}

export function clearAccessToken(): void {
  if (hasStorage()) {
    if (getAccessToken() !== null) sessionIdentityGeneration += 1;
    window.localStorage.removeItem(ACCESS_TOKEN_KEY);
  }
}
